(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-collection-card-swatches"] && !Shopify.designMode) return;
  try {
    
(() => {
  const colorOptionNames = new Set(['color', 'colour']);
  const productCache = new Map();
  const observedCards = new WeakSet();

  const colorMap = {
    black: '#000000',
    white: '#ffffff',
    navy: '#000080',
    'navy-blue': '#000080',
    blue: '#2f6fed',
    'sky-blue': '#87ceeb',
    skyblue: '#87ceeb',
    maroon: '#800020',
    burgundy: '#800020',
    wine: '#800020',
    olive: '#6b7b3e',
    'olive-green': '#6b7b3e',
    red: '#c62828',
    pink: '#e9a1b5',
    'light-pink': '#f5c2cf',
    'hot-pink': '#ff69b4',
    'rose-dust': '#c98f96',
    brown: '#7a4b2a',
    mocha: '#8b6f5a',
    'mocha-desire': '#8b6f5a',
    emerald: '#0f6b50',
    'emerald-green': '#0f6b50',
    rust: '#b7410e',
    beige: '#d9c6a5',
    ivory: '#fff8e7',
    cream: '#fff8e7',
    purple: '#6f42c1',
    lavender: '#b8a2d8',
    yellow: '#f4c430',
    green: '#2e8b57',
    grey: '#808080',
    gray: '#808080',
    'light-grey': '#d3d3d3',
    'light-gray': '#d3d3d3',
    nude: '#d8b08c',
    skin: '#d8b08c',
    'skin-tone': '#d8b08c',
    peach: '#ffcba4',
    orange: '#e67e22',
    teal: '#008080',
    turquoise: '#40e0d0'
  };

  const normalize = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[_\s]+/g, '-');

  const optionName = (option) =>
    typeof option === 'string' ? option : option?.name || '';

  const optionIndex = (product, matcher) => {
    const options = Array.isArray(product?.options) ? product.options : [];
    return options.findIndex((option) => matcher(optionName(option).trim().toLowerCase()));
  };

  const isTshirt = (product) => {
    const title = String(product?.title || '').toLowerCase();
    const type = String(product?.type || product?.product_type || '').toLowerCase();
    const tags = Array.isArray(product?.tags)
      ? product.tags.map((tag) => String(tag).toLowerCase())
      : String(product?.tags || '')
          .split(',')
          .map((tag) => tag.trim().toLowerCase());

    return (
      title.includes('t-shirt') ||
      title.includes('tshirt') ||
      type.includes('t-shirt') ||
      type.includes('tshirt') ||
      tags.includes('comfybliss-womens-tshirt') ||
      tags.includes('unisex-tshirt') ||
      tags.includes('printed-tshirt')
    );
  };

  const productLink = (card) =>
    card.querySelector('.card__heading a[href*="/products/"]') ||
    card.querySelector('a.full-unstyled-link[href*="/products/"]');

  const productJsonUrl = (href) => {
    const url = new URL(href, window.location.origin);
    url.pathname = url.pathname.replace(/\/$/, '') + '.js';
    url.search = '';
    return url;
  };

  const fetchProduct = async (href) => {
    const url = productJsonUrl(href);
    const key = url.pathname;

    if (!productCache.has(key)) {
      productCache.set(
        key,
        fetch(url.toString(), { headers: { Accept: 'application/json' } })
          .then((response) => {
            if (!response.ok) throw new Error('Product option request failed');
            return response.json();
          })
          .catch(() => null)
      );
    }

    return productCache.get(key);
  };

  const optionValue = (variant, index) => {
    if (Array.isArray(variant?.options) && variant.options[index] != null) {
      return variant.options[index];
    }

    return variant?.['option' + (index + 1)] || null;
  };

  const swatchBackground = (name, imageUrl) => {
    const key = normalize(name);

    if (imageUrl) {
      return { type: 'image', value: imageUrl };
    }

    if (colorMap[key]) {
      return { type: 'color', value: colorMap[key] };
    }

    const cssCandidate = key.replace(/-/g, '');
    if (window.CSS?.supports?.('color', cssCandidate)) {
      return { type: 'color', value: cssCandidate };
    }

    return { type: 'color', value: '#e7e4de' };
  };

  const getColorSwatches = (product) => {
    const colorIndex = optionIndex(product, (name) => colorOptionNames.has(name));
    if (colorIndex < 0 || !Array.isArray(product?.variants)) return [];

    const groups = new Map();

    product.variants.forEach((variant) => {
      const value = optionValue(variant, colorIndex);
      if (!value) return;

      if (!groups.has(value)) groups.set(value, []);
      groups.get(value).push(variant);
    });

    return Array.from(groups.entries())
      .map(([name, variants]) => {
        const availableVariants = variants.filter((variant) => variant.available);
        if (!availableVariants.length) return null;

        const variant = availableVariants[0];
        const imageVariant =
          availableVariants.find(
            (candidate) =>
              candidate.featured_image?.src ||
              candidate.featured_image?.url ||
              candidate.featured_media?.preview_image?.src
          ) || variant;

        const image =
          imageVariant.featured_image?.src ||
          imageVariant.featured_image?.url ||
          imageVariant.featured_media?.preview_image?.src ||
          null;

        return { name, variantId: variant.id, image };
      })
      .filter(Boolean);
  };

  const getSizeOptions = (product) => {
    const sizeIndex = optionIndex(product, (name) => name === 'size' || name === 'sizes' || name.includes('size'));
    if (sizeIndex < 0 || !Array.isArray(product?.variants)) return [];

    const groups = new Map();

    product.variants.forEach((variant) => {
      const value = optionValue(variant, sizeIndex);
      if (!value) return;

      if (!groups.has(value)) groups.set(value, []);
      groups.get(value).push(variant);
    });

    return Array.from(groups.entries())
      .map(([name, variants]) => {
        const variant = variants.find((candidate) => candidate.available);
        if (!variant) return null;
        return { name, variantId: variant.id };
      })
      .filter(Boolean);
  };

  const createVariantUrl = (href, variantId) => {
    const destination = new URL(href, window.location.origin);
    destination.searchParams.set('variant', variantId);
    return destination.pathname + destination.search;
  };

  const renderColorSwatches = (card, link, product, price) => {
    const swatches = getColorSwatches(product);
    if (swatches.length < 2) return;

    const container = document.createElement('div');
    container.className = 'cb-card-swatches';
    container.setAttribute('aria-label', 'Color options');

    swatches.forEach((item, index) => {
      const swatchLink = document.createElement('a');
      swatchLink.className = 'cb-card-swatch';
      if (index === 0) swatchLink.classList.add('is-active');
      swatchLink.href = createVariantUrl(link.href, item.variantId);
      swatchLink.title = item.name;
      swatchLink.setAttribute('aria-label', item.name);

      const chip = document.createElement('span');
      chip.className = 'cb-card-swatch__chip';

      const background = swatchBackground(item.name, item.image);
      if (background.type === 'image') {
        chip.style.backgroundImage = 'url("' + background.value + '")';
      } else {
        chip.style.backgroundColor = background.value;
      }

      swatchLink.appendChild(chip);
      container.appendChild(swatchLink);
    });

    price.insertAdjacentElement('afterend', container);
  };

  const renderSizeOptions = (card, link, product, price) => {
    const sizes = getSizeOptions(product);
    if (!sizes.length) return;

    const container = document.createElement('div');
    container.className = 'cb-card-sizes';
    container.setAttribute('aria-label', 'Available sizes');

    sizes.forEach((item) => {
      const sizeLink = document.createElement('a');
      sizeLink.className = 'cb-card-size';
      sizeLink.href = createVariantUrl(link.href, item.variantId);
      sizeLink.title = 'Size ' + item.name;
      sizeLink.setAttribute('aria-label', 'Size ' + item.name);
      sizeLink.textContent = item.name;
      container.appendChild(sizeLink);
    });

    price.insertAdjacentElement('afterend', container);
  };

  const renderOptions = async (card) => {
    if (card.dataset.cbSwatchesReady === 'true') return;

    const link = productLink(card);
    if (!link) return;

    const product = await fetchProduct(link.href);
    if (!product) return;

    card.dataset.cbSwatchesReady = 'true';

    const price = card.querySelector('.card-information .price');
    if (!price || card.querySelector('.cb-card-swatches, .cb-card-sizes')) return;

    if (isTshirt(product)) {
      renderColorSwatches(card, link, product, price);
      return;
    }

    renderSizeOptions(card, link, product, price);
  };

  const intersectionObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              intersectionObserver.unobserve(entry.target);
              renderOptions(entry.target);
            });
          },
          { rootMargin: '300px 0px' }
        )
      : null;

  const queueCard = (card) => {
    if (!card || observedCards.has(card)) return;
    observedCards.add(card);

    if (intersectionObserver) {
      intersectionObserver.observe(card);
    } else {
      renderOptions(card);
    }
  };

  const scan = (root = document) => {
    if (root.matches?.('.product-card-wrapper')) queueCard(root);
    root.querySelectorAll?.('.product-card-wrapper').forEach(queueCard);
  };

  scan(document);

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) scan(node);
      });
    });
  });

  mutationObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-custom-tshirt-builder"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.dataset.cbInitialized==='true')return;
    root.dataset.cbInitialized='true';

    var variants=[];
    try{variants=JSON.parse(root.querySelector('[data-cb-variants]').textContent)}catch(error){return}

    var form=root.querySelector('form');
    var variantInput=root.querySelector('[data-variant-id]');
    var priceNode=root.querySelector('[data-price]');
    var submitButton=root.querySelector('[data-submit]');
    var formError=root.querySelector('[data-form-error]');
    var shirtImage=root.querySelector('[data-shirt-image]');
    var previewSideLabel=root.querySelector('[data-preview-side-label]');
    var printArea=root.querySelector('[data-print-area]');
    var placeholder=root.querySelector('[data-placeholder]');
    var designGroup=root.querySelector('[data-design-group]');
    var artwork=root.querySelector('[data-artwork-preview]');
    var textPreview=root.querySelector('[data-text-preview]');
    var printSidesProperty=root.querySelector('[data-print-sides-property]');
    var propColor=root.querySelector('[data-prop-color]');
    var designGroupProperty=root.querySelector('[data-design-group-property]');
    var primaryQuantity=root.querySelector('[data-primary-quantity]');
    var primarySummary=root.querySelector('[data-primary-summary]');
    var extraShirts=root.querySelector('[data-extra-shirts]');
    var addShirtButton=root.querySelector('[data-add-shirt]');
    var discountMessage=root.querySelector('[data-discount-message]');
    var isAdding=false;

    var colorButtons=Array.prototype.slice.call(root.querySelectorAll('[data-color]'));
    var sizeButtons=Array.prototype.slice.call(root.querySelectorAll('[data-size]'));
    var printModeButtons=Array.prototype.slice.call(root.querySelectorAll('[data-print-mode]'));
    var editSideButtons=Array.prototype.slice.call(root.querySelectorAll('[data-edit-side]'));
    var sidePanels=Array.prototype.slice.call(root.querySelectorAll('[data-side-panel]'));
    var sideTabs=root.querySelector('[data-side-tabs]');

    var selectedColor=root.dataset.startColor||'Black';
    var selectedSize=root.dataset.startSize||'S';
    var printMode='front';
    var activeSide='front';
    var dragging=false;
    var focusDragging=false;
    var focusDragStart=null;

    var frontImages={
      'Black':root.dataset.frontBlack,
      'Navy':root.dataset.frontNavy,
      'White':root.dataset.frontWhite,
      'Beige':root.dataset.frontBeige
    };
    var backImages={
      'Black':root.dataset.backBlack,
      'Navy':root.dataset.backNavy,
      'White':root.dataset.backWhite,
      'Beige':root.dataset.backBeige
    };

    function newSide(){
      return{
        type:'image',
        objectUrl:'',
        naturalWidth:0,
        text:'',
        font:'Montserrat',
        textColor:'#ffffff',
        textSize:28,
        bold:false,
        italic:false,
        underline:false,
        textAlign:'center',
        textCase:'none',
        letterSpacing:0,
        lineHeight:1.05,
        x:50,
        y:50,
        scale:55,
        focusX:50,
        focusY:50,
        focusMode:false,
        rotation:0,
        alignment:'Center'
      };
    }

    var state={front:newSide(),back:newSide()};

    function q(selector,side){return root.querySelector(selector+'="'+side+'"]')}

    function getVariant(color,size){
      return variants.find(function(v){return v.color===color&&v.size===size});
    }

    function formatMoney(cents){
      var amount=(Number(cents)||0)/100;
      var formatted=amount.toLocaleString('en-PK',{minimumFractionDigits:2,maximumFractionDigits:2});
      var currency=root.dataset.currency||'PKR';
      return currency==='PKR'?'Rs. '+formatted:currency+' '+formatted;
    }

    function positiveQuantity(value){
      var quantity=parseInt(value,10);
      if(!Number.isFinite(quantity)||quantity<1)return 1;
      return Math.min(quantity,99);
    }

    function updateExtraSizeOptions(row){
      var color=row.querySelector('[data-extra-color]').value;
      var sizeSelect=row.querySelector('[data-extra-size]');
      var previous=sizeSelect.value;
      sizeSelect.innerHTML='';
      var sizes=[];
      variants.forEach(function(variant){
        if(variant.color===color&&sizes.indexOf(variant.size)===-1)sizes.push(variant.size);
      });
      sizes.forEach(function(size){
        var variant=getVariant(color,size);
        var option=document.createElement('option');
        option.value=size;
        option.textContent=size;
        option.disabled=!variant||!variant.available;
        sizeSelect.appendChild(option);
      });
      var priorOption=Array.prototype.find.call(sizeSelect.options,function(option){return option.value===previous&&!option.disabled});
      if(priorOption){
        sizeSelect.value=previous;
      }else{
        var firstAvailable=Array.prototype.find.call(sizeSelect.options,function(option){return!option.disabled});
        if(firstAvailable)sizeSelect.value=firstAvailable.value;
      }
    }

    function createExtraRow(){
      var row=document.createElement('div');
      row.className='cb-custom-tshirt__extra-row';
      row.innerHTML=
        '<label class="cb-custom-tshirt__extra-field"><span>'+root.dataset.extraColorLabel+'</span><select data-extra-color></select></label>'+
        '<label class="cb-custom-tshirt__extra-field"><span>'+root.dataset.extraSizeLabel+'</span><select data-extra-size></select></label>'+
        '<label class="cb-custom-tshirt__extra-field"><span>'+root.dataset.extraQuantityLabel+'</span><input type="number" min="1" max="99" step="1" value="1" inputmode="numeric" data-extra-quantity></label>'+
        '<button type="button" class="cb-custom-tshirt__remove-shirt" data-remove-extra>'+root.dataset.removeShirtLabel+'</button>';

      var colorSelect=row.querySelector('[data-extra-color]');
      var colors=[];
      variants.forEach(function(variant){
        if(colors.indexOf(variant.color)===-1)colors.push(variant.color);
      });
      colors.forEach(function(color){
        var option=document.createElement('option');
        option.value=color;
        option.textContent=color;
        colorSelect.appendChild(option);
      });
      colorSelect.value=selectedColor;
      updateExtraSizeOptions(row);
      var sizeSelect=row.querySelector('[data-extra-size]');
      var matching=Array.prototype.find.call(sizeSelect.options,function(option){return option.value===selectedSize&&!option.disabled});
      if(matching)sizeSelect.value=selectedSize;

      colorSelect.addEventListener('change',function(){
        updateExtraSizeOptions(row);
        updateQuantitySummary();
      });
      sizeSelect.addEventListener('change',updateQuantitySummary);
      row.querySelector('[data-extra-quantity]').addEventListener('input',updateQuantitySummary);
      row.querySelector('[data-remove-extra]').addEventListener('click',function(){
        row.remove();
        updateQuantitySummary();
      });
      extraShirts.appendChild(row);
      updateQuantitySummary();
    }

    function collectSelections(){
      var selections=[];
      var primaryVariant=getVariant(selectedColor,selectedSize);
      if(primaryVariant&&primaryVariant.available){
        selections.push({
          id:primaryVariant.id,
          color:selectedColor,
          size:selectedSize,
          quantity:positiveQuantity(primaryQuantity.value),
          price:Number(primaryVariant.price)||0
        });
      }

      Array.prototype.forEach.call(extraShirts.querySelectorAll('.cb-custom-tshirt__extra-row'),function(row){
        var color=row.querySelector('[data-extra-color]').value;
        var size=row.querySelector('[data-extra-size]').value;
        var quantity=positiveQuantity(row.querySelector('[data-extra-quantity]').value);
        var variant=getVariant(color,size);
        if(variant&&variant.available){
          selections.push({id:variant.id,color:color,size:size,quantity:quantity,price:Number(variant.price)||0});
        }
      });

      var merged={};
      selections.forEach(function(item){
        if(!merged[item.id]){
          merged[item.id]={id:item.id,color:item.color,size:item.size,quantity:0,price:item.price};
        }
        merged[item.id].quantity+=item.quantity;
      });
      return Object.keys(merged).map(function(id){return merged[id]});
    }

    function updateQuantitySummary(){
      primaryQuantity.value=String(positiveQuantity(primaryQuantity.value));
      primarySummary.textContent=selectedColor+' / '+selectedSize;
      var selections=collectSelections();
      var total=selections.reduce(function(sum,item){return sum+item.quantity},0);
      var subtotal=selections.reduce(function(sum,item){
        return sum+(Number(item.price)||0)*item.quantity;
      },0);
      var discountedTotal=subtotal;

      if(total>=5){
        discountedTotal=Math.round(subtotal*0.80);
        discountMessage.textContent=root.dataset.totalShirtsLabel+': '+total+' · '+root.dataset.discountBulk;
      }else if(total>=2){
        var cheapestUnitPrice=0;
        selections.forEach(function(item){
          var unitPrice=Number(item.price)||0;
          if(unitPrice>0&&(cheapestUnitPrice===0||unitPrice<cheapestUnitPrice)){
            cheapestUnitPrice=unitPrice;
          }
        });
        discountedTotal=subtotal-Math.round(cheapestUnitPrice*0.10);
        discountMessage.textContent=root.dataset.totalShirtsLabel+': '+total+' · '+root.dataset.discountSecond;
      }else{
        discountMessage.textContent=root.dataset.totalShirtsLabel+': '+total+' · '+root.dataset.discountSingle;
      }

      priceNode.textContent=formatMoney(discountedTotal);
    }

    function designGroupId(){
      return 'CB-'+Date.now().toString(36).toUpperCase()+'-'+Math.random().toString(36).slice(2,7).toUpperCase();
    }

    function enabledSides(){
      if(printMode==='both')return['front','back'];
      return[printMode];
    }

    function sideEnabled(side){
      return enabledSides().indexOf(side)!==-1;
    }

    function setFieldsEnabled(side,enabled){
      Array.prototype.forEach.call(root.querySelectorAll('[data-side-field="'+side+'"]'),function(field){
        field.disabled=!enabled;
      });
    }

    function syncDesignTypeFields(side){
      var s=state[side];
      var c=controls(side);
      var enabled=sideEnabled(side);
      var imageEnabled=enabled&&(s.type==='image'||s.type==='both');
      var textEnabled=enabled&&(s.type==='text'||s.type==='both');

      Array.prototype.forEach.call(c.imageFields.querySelectorAll('input,select,textarea'),function(field){
        field.disabled=!imageEnabled;
      });
      Array.prototype.forEach.call(c.textFields.querySelectorAll('input,select,textarea'),function(field){
        field.disabled=!textEnabled;
      });
      c.focusWrap.hidden=!imageEnabled;
      Array.prototype.forEach.call(root.querySelectorAll('[data-image-focus-field="'+side+'"]'),function(field){
        field.disabled=!imageEnabled;
      });
      if(!imageEnabled){
        s.focusMode=false;
        c.focusButton.classList.remove('is-active');
        c.focusButton.textContent=root.dataset.focusStart;
      }
    }

    function setActiveSide(side){
      if(!sideEnabled(side))return;
      activeSide=side;
      sidePanels.forEach(function(panel){panel.hidden=panel.dataset.sidePanel!==side});
      editSideButtons.forEach(function(button){
        var active=button.dataset.editSide===side;
        button.classList.toggle('is-selected',active);
        button.setAttribute('aria-pressed',active?'true':'false');
      });
      previewSideLabel.textContent=side==='front'?'Front':'Back';
      renderShirt();
      syncControlsFromState(side);
      renderDesign();
    }

    function setPrintMode(mode){
      printMode=mode;
      printModeButtons.forEach(function(button){
        var active=button.dataset.printMode===mode;
        button.classList.toggle('is-selected',active);
        button.setAttribute('aria-pressed',active?'true':'false');
      });
      sideTabs.hidden=mode!=='both';
      setFieldsEnabled('front',mode==='front'||mode==='both');
      setFieldsEnabled('back',mode==='back'||mode==='both');
      syncDesignTypeFields('front');
      syncDesignTypeFields('back');
      printSidesProperty.value=mode==='front'?'Front only':mode==='back'?'Back only':'Front + back';
      if(mode==='front')setActiveSide('front');
      if(mode==='back')setActiveSide('back');
      if(mode==='both'&&!sideEnabled(activeSide))setActiveSide('front');
      formError.hidden=true;
    }

    function updateVariant(){
      var current=getVariant(selectedColor,selectedSize);
      if(!current||!current.available){
        var first=sizeButtons.find(function(button){
          var candidate=getVariant(selectedColor,button.dataset.size);
          return candidate&&candidate.available;
        });
        if(first)selectedSize=first.dataset.size;
      }
      var variant=getVariant(selectedColor,selectedSize);

      colorButtons.forEach(function(button){
        var active=button.dataset.color===selectedColor;
        button.classList.toggle('is-selected',active);
        button.setAttribute('aria-pressed',active?'true':'false');
      });

      sizeButtons.forEach(function(button){
        var candidate=getVariant(selectedColor,button.dataset.size);
        button.disabled=!candidate||!candidate.available;
        var active=button.dataset.size===selectedSize;
        button.classList.toggle('is-selected',active);
        button.setAttribute('aria-pressed',active?'true':'false');
      });

      propColor.value=selectedColor;
      renderShirt();

      if(!variant){
        submitButton.disabled=true;
        submitButton.textContent=root.dataset.soldOutLabel;
        return;
      }
      variantInput.value=variant.id;
      priceNode.textContent=variant.priceFormatted;
      submitButton.disabled=!variant.available;
      submitButton.textContent=variant.available?root.dataset.addLabel:root.dataset.soldOutLabel;
      updateQuantitySummary();
    }

    function renderShirt(){
      var map=activeSide==='front'?frontImages:backImages;
      if(map[selectedColor])shirtImage.src=map[selectedColor];
    }

    function controls(side){
      return{
        type:q('[data-design-type',side),
        imageFields:q('[data-image-fields',side),
        textFields:q('[data-text-fields',side),
        file:q('[data-artwork-input',side),
        quality:q('[data-quality-status',side),
        text:q('[data-text-input',side),
        font:q('[data-font-input',side),
        customFont:q('[data-custom-font-input',side),
        fontProperty:q('[data-font-property',side),
        textColor:q('[data-text-color',side),
        textSize:q('[data-text-size',side),
        textSizeOutput:q('[data-text-size-output',side),
        bold:q('[data-text-bold',side),
        italic:q('[data-text-italic',side),
        underline:q('[data-text-underline',side),
        textAlign:q('[data-text-align',side),
        textCase:q('[data-text-case',side),
        letterSpacing:q('[data-letter-spacing',side),
        letterSpacingOutput:q('[data-letter-spacing-output',side),
        lineHeight:q('[data-line-height',side),
        lineHeightOutput:q('[data-line-height-output',side),
        scale:q('[data-scale-control',side),
        scaleOutput:q('[data-scale-output',side),
        focusWrap:q('[data-image-focus-controls',side),
        focusButton:q('[data-focus-mode-toggle',side),
        focusX:q('[data-focus-x',side),
        focusXOutput:q('[data-focus-x-output',side),
        focusY:q('[data-focus-y',side),
        focusYOutput:q('[data-focus-y-output',side),
        rotation:q('[data-rotation-control',side),
        rotationOutput:q('[data-rotation-output',side),
        propX:q('[data-prop-x',side),
        propY:q('[data-prop-y',side),
        propScale:q('[data-prop-scale',side),
        propFocusX:q('[data-prop-focus-x',side),
        propFocusY:q('[data-prop-focus-y',side),
        propRotation:q('[data-prop-rotation',side),
        propAlignment:q('[data-prop-alignment',side),
        propDpi:q('[data-prop-dpi',side),
        propDesignType:q('[data-prop-design-type',side),
        propBold:q('[data-prop-bold',side),
        propItalic:q('[data-prop-italic',side),
        propUnderline:q('[data-prop-underline',side),
        propTextSize:q('[data-prop-text-size',side),
        propLetterSpacing:q('[data-prop-letter-spacing',side),
        propLineHeight:q('[data-prop-line-height',side),
        propImageTextGap:q('[data-prop-image-text-gap',side),
        alignmentGrid:q('[data-alignment-grid',side)
      };
    }

    function syncControlsFromState(side){
      var s=state[side];
      var c=controls(side);
      c.type.value=s.type;
      c.imageFields.hidden=s.type==='text';
      c.textFields.hidden=s.type==='image';
      syncDesignTypeFields(side);
      c.text.value=s.text;
      var fontOptionExists=Array.prototype.some.call(c.font.options,function(option){return option.value===s.font});
      if(fontOptionExists){
        c.font.value=s.font;
        c.customFont.hidden=true;
      }else{
        c.font.value='__custom__';
        c.customFont.hidden=false;
        c.customFont.value=s.font;
      }
      c.fontProperty.value=s.font;
      c.textColor.value=s.textColor;
      c.textSize.value=String(s.textSize);
      c.textSizeOutput.textContent=s.textSize+'px';
      c.bold.checked=s.bold;
      c.italic.checked=s.italic;
      c.underline.checked=s.underline;
      c.textAlign.value=s.textAlign;
      c.textCase.value=s.textCase;
      c.letterSpacing.value=String(s.letterSpacing);
      c.letterSpacingOutput.textContent=s.letterSpacing+'px';
      c.lineHeight.value=String(s.lineHeight);
      c.lineHeightOutput.textContent=Number(s.lineHeight).toFixed(2).replace(/0+$/,'').replace(/\.$/,'');
      c.scale.value=String(s.scale);
      c.scaleOutput.textContent=s.scale+'%';
      c.focusX.value=String(s.focusX);
      c.focusXOutput.textContent=s.focusX+'%';
      c.focusY.value=String(s.focusY);
      c.focusYOutput.textContent=s.focusY+'%';
      c.focusButton.classList.toggle('is-active',s.focusMode);
      c.focusButton.textContent=s.focusMode?root.dataset.focusDone:root.dataset.focusStart;
      c.rotation.value=String(s.rotation);
      c.rotationOutput.textContent=s.rotation+'°';
      Array.prototype.forEach.call(c.alignmentGrid.querySelectorAll('[data-align]'),function(button){
        button.classList.toggle('is-selected',labelForAlignment(button.dataset.align)===s.alignment);
      });
      writeSideProperties(side);
    }

    var webSafeFonts=['Arial','Arial Black','Verdana','Tahoma','Trebuchet MS','Georgia','Times New Roman','Courier New'];
    var loadedFonts={};

    function ensureFontLoaded(name){
      if(!name||webSafeFonts.indexOf(name)!==-1||loadedFonts[name])return;
      loadedFonts[name]=true;
      var link=document.createElement('link');
      link.rel='stylesheet';
      link.href='https://fonts.googleapis.com/css2?family='+encodeURIComponent(name).replace(/%20/g,'+')+'&display=swap';
      document.head.appendChild(link);
    }

    function fontFamily(name){
      var family=(name||'Montserrat').trim();
      ensureFontLoaded(family);
      return '"'+family.replace(/"/g,'')+'", Arial, sans-serif';
    }

    function imageFocusCapacity(){
      return{
        x:Math.max(0,(artwork.offsetWidth-printArea.clientWidth)/2),
        y:Math.max(0,(artwork.offsetHeight-printArea.clientHeight)/2)
      };
    }

    function applyImageFocus(s){
      if(artwork.hidden){
        artwork.style.transform='none';
        return;
      }
      var capacity=imageFocusCapacity();
      var shiftX=capacity.x*(1-(s.focusX/50));
      var shiftY=capacity.y*(1-(s.focusY/50));
      artwork.style.transform='translate('+shiftX+'px,'+shiftY+'px)';
    }

    function renderDesign(){
      var s=state[activeSide];
      var hasImage=s.type!=='text'&&!!s.objectUrl;
      var hasText=s.type!=='image'&&!!s.text.trim();

      designGroup.hidden=!(hasImage||hasText);
      placeholder.hidden=hasImage||hasText;

      artwork.hidden=!hasImage;
      if(hasImage){
        if(artwork.src!==s.objectUrl)artwork.src=s.objectUrl;
      }else{
        artwork.removeAttribute('src');
      }

      textPreview.hidden=!hasText;
      textPreview.textContent=s.text;
      textPreview.style.fontFamily=fontFamily(s.font);
      textPreview.style.fontWeight=s.bold?'800':'400';
      textPreview.style.fontStyle=s.italic?'italic':'normal';
      textPreview.style.textDecoration=s.underline?'underline':'none';
      textPreview.style.textAlign=s.textAlign;
      textPreview.style.textTransform=s.textCase;
      textPreview.style.letterSpacing=s.letterSpacing+'px';
      textPreview.style.textIndent=s.textAlign==='center'?s.letterSpacing+'px':'0px';
      textPreview.style.lineHeight=String(s.lineHeight);
      textPreview.style.color=s.textColor;
      textPreview.style.fontSize=s.textSize+'px';

      var textOnly=s.type==='text';
      designGroup.style.left=textOnly?'50%':s.x+'%';
      designGroup.style.top=s.y+'%';
      designGroup.style.width=textOnly?'100%':s.scale+'%';
      designGroup.style.maxWidth=textOnly?'100%':'none';
      designGroup.style.transform='translate(-50%, -50%) rotate('+s.rotation+'deg)';
      designGroup.style.cursor=s.focusMode?'move':'grab';
      textPreview.style.marginTop=(s.type==='both'&&hasImage)?'10px':'4px';

      if(hasText){
        var printWidth=Math.max(printArea.clientWidth,1);
        var groupWidth=Math.max(designGroup.offsetWidth,1);
        var groupCenter=textOnly?printWidth/2:(s.x/100)*printWidth;
        var groupLeft=groupCenter-(groupWidth/2);
        textPreview.style.width=printWidth+'px';
        textPreview.style.maxWidth='none';
        textPreview.style.marginLeft=(-groupLeft)+'px';
      }else{
        textPreview.style.width='100%';
        textPreview.style.maxWidth='100%';
        textPreview.style.marginLeft='0';
      }

      applyImageFocus(s);
      writeSideProperties(activeSide);
    }

    function writeSideProperties(side){
      var s=state[side];
      var c=controls(side);
      c.propX.value=s.x.toFixed(1)+'%';
      c.propY.value=s.y.toFixed(1)+'%';
      c.propScale.value=s.scale+'%';
      c.propFocusX.value=s.focusX+'%';
      c.propFocusY.value=s.focusY+'%';
      c.propRotation.value=s.rotation+'°';
      c.propAlignment.value=s.alignment;
      c.propDesignType.value=s.type==='image'?'Image only':s.type==='text'?'Text only':'Image + text';
      c.propBold.value=s.bold?'Yes':'No';
      c.propItalic.value=s.italic?'Yes':'No';
      c.propUnderline.value=s.underline?'Yes':'No';
      c.propTextSize.value=s.textSize+'px';
      c.propLetterSpacing.value=s.letterSpacing+'px';
      c.propLineHeight.value=Number(s.lineHeight).toFixed(2).replace(/0+$/,'').replace(/\.$/,'');
      c.propImageTextGap.value=s.type==='both'?'10px':'Not applicable';
      updateQuality(side);
    }

    function updateQuality(side){
      var s=state[side];
      var c=controls(side);
      c.quality.classList.remove('is-good','is-ok','is-low','is-error');
      if(!s.naturalWidth){
        c.propDpi.value='';
        c.quality.textContent=root.dataset.qualityWaiting;
        return;
      }
      var printWidthInches=11*(s.scale/100);
      var dpi=Math.round(s.naturalWidth/Math.max(printWidthInches,.1));
      c.propDpi.value=String(dpi);
      if(dpi>=250){
        c.quality.classList.add('is-good');
        c.quality.textContent=root.dataset.qualityGood+' · '+s.naturalWidth+' px · ~'+dpi+' DPI';
      }else if(dpi>=150){
        c.quality.classList.add('is-ok');
        c.quality.textContent=root.dataset.qualityOk+' · '+s.naturalWidth+' px · ~'+dpi+' DPI';
      }else{
        c.quality.classList.add('is-low');
        c.quality.textContent=root.dataset.qualityLow+' · '+s.naturalWidth+' px · ~'+dpi+' DPI';
      }
    }

    function labelForAlignment(code){
      var map={
        'top-left':'Top left',
        'top-center':'Top center',
        'top-right':'Top right',
        'middle-left':'Middle left',
        'center':'Center',
        'middle-right':'Middle right',
        'bottom-left':'Bottom left',
        'bottom-center':'Bottom center',
        'bottom-right':'Bottom right'
      };
      return map[code]||'Center';
    }

    function clamp(value,min,max){return Math.max(min,Math.min(max,value))}

    function groupHalfPercent(){
      var halfW=(designGroup.offsetWidth/Math.max(printArea.clientWidth,1))*50;
      var halfH=(designGroup.offsetHeight/Math.max(printArea.clientHeight,1))*50;
      return{
        x:clamp(halfW,5,46),
        y:clamp(halfH,5,46)
      };
    }

    function alignDesign(side,code){
      if(side!==activeSide)setActiveSide(side);
      var s=state[side];
      var half=groupHalfPercent();
      var left=half.x+2;
      var right=100-half.x-2;
      var top=half.y+2;
      var bottom=100-half.y-2;
      var x=50;
      var y=50;

      if(code.indexOf('left')!==-1)x=left;
      if(code.indexOf('right')!==-1)x=right;
      if(code.indexOf('top')!==-1)y=top;
      if(code.indexOf('bottom')!==-1)y=bottom;

      s.x=clamp(x,left,right);
      s.y=clamp(y,top,bottom);
      s.alignment=labelForAlignment(code);
      syncControlsFromState(side);
      renderDesign();
    }

    function resetSide(side){
      var s=state[side];
      s.x=50;
      s.y=50;
      s.scale=55;
      s.focusX=50;
      s.focusY=50;
      s.focusMode=false;
      s.rotation=0;
      s.alignment='Center';
      syncControlsFromState(side);
      if(side===activeSide)renderDesign();
    }

    function validateFile(side,file){
      var c=controls(side);
      c.quality.classList.remove('is-good','is-ok','is-low','is-error');
      if(!file)return true;
      if(!/^image\/(png|jpeg)$/.test(file.type)){
        c.file.setCustomValidity(root.dataset.invalidFile);
        c.quality.classList.add('is-error');
        c.quality.textContent=root.dataset.invalidFile;
        return false;
      }
      if(file.size>10*1024*1024){
        c.file.setCustomValidity(root.dataset.fileTooLarge);
        c.quality.classList.add('is-error');
        c.quality.textContent=root.dataset.fileTooLarge;
        return false;
      }
      c.file.setCustomValidity('');
      return true;
    }

    function sideComplete(side){
      var s=state[side];
      if(s.type==='image')return!!controls(side).file.files[0];
      if(s.type==='text')return!!s.text.trim();
      return!!controls(side).file.files[0]&&!!s.text.trim();
    }

    function missingMessage(side){
      var s=state[side];
      if((s.type==='image'||s.type==='both')&&!controls(side).file.files[0])return root.dataset.missingImage;
      if((s.type==='text'||s.type==='both')&&!s.text.trim())return root.dataset.missingText;
      return side==='front'?root.dataset.frontMissing:root.dataset.backMissing;
    }

    printModeButtons.forEach(function(button){
      button.addEventListener('click',function(){setPrintMode(button.dataset.printMode)});
    });

    editSideButtons.forEach(function(button){
      button.addEventListener('click',function(){setActiveSide(button.dataset.editSide)});
    });

    colorButtons.forEach(function(button){
      button.addEventListener('click',function(){
        selectedColor=button.dataset.color;
        updateVariant();
      });
    });

    sizeButtons.forEach(function(button){
      button.addEventListener('click',function(){
        if(button.disabled)return;
        selectedSize=button.dataset.size;
        updateVariant();
      });
    });

    primaryQuantity.addEventListener('input',updateQuantitySummary);
    addShirtButton.addEventListener('click',createExtraRow);

    ['front','back'].forEach(function(side){
      var c=controls(side);

      c.type.addEventListener('change',function(){
        state[side].type=c.type.value;
        c.imageFields.hidden=state[side].type==='text';
        c.textFields.hidden=state[side].type==='image';
        if(state[side].type==='text'){
          state[side].focusMode=false;
          state[side].x=50;
          state[side].alignment='Center';
        }
        syncDesignTypeFields(side);
        syncControlsFromState(side);
        if(side===activeSide)renderDesign();
      });

      c.file.addEventListener('change',function(){
        var file=c.file.files&&c.file.files[0];
        if(!validateFile(side,file))return;
        if(!file){
          if(state[side].objectUrl)URL.revokeObjectURL(state[side].objectUrl);
          state[side].objectUrl='';
          state[side].naturalWidth=0;
          if(side===activeSide)renderDesign();
          updateQuality(side);
          return;
        }
        if(state[side].objectUrl)URL.revokeObjectURL(state[side].objectUrl);
        state[side].objectUrl=URL.createObjectURL(file);
        var probe=new Image();
        probe.onload=function(){
          state[side].naturalWidth=probe.naturalWidth||0;
          resetSide(side);
          state[side].focusX=50;
          state[side].focusY=50;
          updateQuality(side);
          syncControlsFromState(side);
          if(side===activeSide)renderDesign();
        };
        probe.src=state[side].objectUrl;
      });

      c.text.addEventListener('input',function(){
        state[side].text=c.text.value;
        if(side===activeSide)renderDesign();
      });

      c.font.addEventListener('change',function(){
        if(c.font.value==='__custom__'){
          c.customFont.hidden=false;
          state[side].font=c.customFont.value.trim()||'Montserrat';
        }else{
          c.customFont.hidden=true;
          state[side].font=c.font.value;
        }
        c.fontProperty.value=state[side].font;
        ensureFontLoaded(state[side].font);
        if(side===activeSide)renderDesign();
      });

      c.customFont.addEventListener('input',function(){
        if(c.font.value!=='__custom__')return;
        state[side].font=c.customFont.value.trim()||'Montserrat';
        c.fontProperty.value=state[side].font;
        ensureFontLoaded(state[side].font);
        if(side===activeSide)renderDesign();
      });

      c.bold.addEventListener('change',function(){
        state[side].bold=c.bold.checked;
        if(side===activeSide)renderDesign();
      });

      c.italic.addEventListener('change',function(){
        state[side].italic=c.italic.checked;
        if(side===activeSide)renderDesign();
      });

      c.underline.addEventListener('change',function(){
        state[side].underline=c.underline.checked;
        if(side===activeSide)renderDesign();
      });

      c.textAlign.addEventListener('change',function(){
        state[side].textAlign=c.textAlign.value;
        if(side===activeSide)renderDesign();
      });

      c.textCase.addEventListener('change',function(){
        state[side].textCase=c.textCase.value;
        if(side===activeSide)renderDesign();
      });

      c.letterSpacing.addEventListener('input',function(){
        state[side].letterSpacing=Number(c.letterSpacing.value);
        c.letterSpacingOutput.textContent=state[side].letterSpacing+'px';
        if(side===activeSide)renderDesign();
      });

      c.lineHeight.addEventListener('input',function(){
        state[side].lineHeight=Number(c.lineHeight.value);
        c.lineHeightOutput.textContent=state[side].lineHeight.toFixed(2).replace(/0+$/,'').replace(/\.$/,'');
        if(side===activeSide)renderDesign();
      });

      c.textColor.addEventListener('input',function(){
        state[side].textColor=c.textColor.value;
        if(side===activeSide)renderDesign();
      });

      c.textSize.addEventListener('input',function(){
        state[side].textSize=Number(c.textSize.value);
        c.textSizeOutput.textContent=state[side].textSize+'px';
        if(side===activeSide)renderDesign();
      });

      c.scale.addEventListener('input',function(){
        state[side].scale=Number(c.scale.value);
        c.scaleOutput.textContent=state[side].scale+'%';
        state[side].alignment='Custom';

        var hasImage=state[side].type!=='text'&&!!state[side].objectUrl;
        if(hasImage&&state[side].scale>100){
          state[side].focusMode=true;
        }else if(state[side].scale<=100){
          state[side].focusMode=false;
        }

        syncControlsFromState(side);
        if(side===activeSide)renderDesign();
        writeSideProperties(side);
      });

      c.focusButton.addEventListener('click',function(){
        state[side].focusMode=!state[side].focusMode;
        syncControlsFromState(side);
        if(side===activeSide)renderDesign();
      });

      c.focusX.addEventListener('input',function(){
        state[side].focusX=Number(c.focusX.value);
        c.focusXOutput.textContent=state[side].focusX+'%';
        if(side===activeSide)renderDesign();
        writeSideProperties(side);
      });

      c.focusY.addEventListener('input',function(){
        state[side].focusY=Number(c.focusY.value);
        c.focusYOutput.textContent=state[side].focusY+'%';
        if(side===activeSide)renderDesign();
        writeSideProperties(side);
      });

      c.rotation.addEventListener('input',function(){
        state[side].rotation=Number(c.rotation.value);
        c.rotationOutput.textContent=state[side].rotation+'°';
        state[side].alignment='Custom';
        if(side===activeSide)renderDesign();
        writeSideProperties(side);
      });

      Array.prototype.forEach.call(c.alignmentGrid.querySelectorAll('[data-align]'),function(button){
        button.addEventListener('click',function(){alignDesign(side,button.dataset.align)});
      });

      root.querySelector('[data-reset-position="'+side+'"]').addEventListener('click',function(){resetSide(side)});
    });

    designGroup.addEventListener('pointerdown',function(event){
      if(designGroup.hidden)return;
      var s=state[activeSide];
      var hasImage=s.type!=='text'&&!!s.objectUrl;
      if(hasImage&&s.scale>100&&!s.focusMode){
        s.focusMode=true;
        syncControlsFromState(activeSide);
      }
      focusDragging=!!(s.focusMode&&hasImage&&s.scale>100);
      dragging=!focusDragging;
      if(focusDragging){
        focusDragStart={
          x:event.clientX,
          y:event.clientY,
          focusX:s.focusX,
          focusY:s.focusY
        };
      }
      designGroup.setPointerCapture(event.pointerId);
      event.preventDefault();
    });

    designGroup.addEventListener('pointermove',function(event){
      var s=state[activeSide];

      if(focusDragging&&focusDragStart){
        var capacity=imageFocusCapacity();
        if(capacity.x>0){
          s.focusX=clamp(focusDragStart.focusX-((event.clientX-focusDragStart.x)*50/capacity.x),0,100);
        }
        if(capacity.y>0){
          s.focusY=clamp(focusDragStart.focusY-((event.clientY-focusDragStart.y)*50/capacity.y),0,100);
        }
        s.focusX=Math.round(s.focusX);
        s.focusY=Math.round(s.focusY);
        renderDesign();
        syncControlsFromState(activeSide);
        return;
      }

      if(!dragging)return;
      var rect=printArea.getBoundingClientRect();
      var half=groupHalfPercent();
      var rawX=((event.clientX-rect.left)/rect.width)*100;
      var rawY=((event.clientY-rect.top)/rect.height)*100;
      s.x=clamp(rawX,half.x+1,100-half.x-1);
      s.y=clamp(rawY,half.y+1,100-half.y-1);
      s.alignment='Custom';
      renderDesign();
      syncControlsFromState(activeSide);
    });

    function endDrag(event){
      if(!dragging&&!focusDragging)return;
      dragging=false;
      focusDragging=false;
      focusDragStart=null;
      if(designGroup.hasPointerCapture(event.pointerId))designGroup.releasePointerCapture(event.pointerId);
    }

    designGroup.addEventListener('pointerup',endDrag);
    designGroup.addEventListener('pointercancel',endDrag);

    form.addEventListener('submit',async function(event){
      event.preventDefault();
      if(isAdding)return;
      formError.hidden=true;

      var sides=enabledSides();
      for(var i=0;i<sides.length;i++){
        var side=sides[i];
        if(!sideComplete(side)){
          setActiveSide(side);
          formError.textContent=missingMessage(side);
          formError.hidden=false;
          formError.scrollIntoView({behavior:'smooth',block:'center'});
          return;
        }
      }

      var selections=collectSelections();
      if(!selections.length){
        formError.textContent=root.dataset.quantityError;
        formError.hidden=false;
        return;
      }

      var groupId=designGroupId();
      designGroupProperty.value=groupId;
      var baseData=new FormData(form);
      baseData.delete('id');
      baseData.delete('quantity');

      isAdding=true;
      submitButton.disabled=true;
      submitButton.textContent=root.dataset.addingLabel;

      try{
        for(var index=0;index<selections.length;index++){
          var item=selections[index];
          var itemData=new FormData();
          itemData.append('id',item.id);
          itemData.append('quantity',String(item.quantity));

          baseData.forEach(function(value,key){
            if(key.indexOf('properties[')===0){
              itemData.append(key,value);
            }
          });

          itemData.set('properties[_Design group]',groupId);
          itemData.set('properties[_Preview color]',item.color);
          itemData.set('properties[_Same design across shirts]','Yes');

          var response=await fetch((window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/')+'cart/add.js',{
            method:'POST',
            body:itemData,
            headers:{'Accept':'application/json'}
          });

          if(!response.ok){
            var errorData={};
            try{errorData=await response.json()}catch(error){}
            throw new Error(errorData.description||root.dataset.cartAddError);
          }
        }

        window.location.href=(window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/')+'cart';
      }catch(error){
        formError.textContent=error&&error.message?error.message:root.dataset.cartAddError;
        formError.hidden=false;
        isAdding=false;
        submitButton.disabled=false;
        submitButton.textContent=root.dataset.addLabel;
      }
    });

    setPrintMode('front');
    updateVariant();
    updateQuantitySummary();
    syncControlsFromState('front');
    syncControlsFromState('back');
    renderDesign();
  }

  function initAll(scope){
    var roots=scope.querySelectorAll?scope.querySelectorAll('[data-cb-customizer]'):[];
    Array.prototype.forEach.call(roots,init);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){initAll(document)});
  }else{
    initAll(document);
  }

  document.addEventListener('shopify:section:load',function(event){initAll(event.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-hide-sold-out-bak"]) return;
  try {
    
  (() => {
    let scheduled = false;

    const prunePredictiveSoldOut = () => {
      scheduled = false;
      const items = Array.from(
        document.querySelectorAll('#predictive-search-results-products-list .predictive-search__list-item:not([data-cb-stock-checked])')
      );
      if (!items.length) return;

      items.forEach((item) => {
        item.dataset.cbStockChecked = 'true';
        const link = item.querySelector('a[href*="/products/"]');
        if (!link) return;

        let url;
        try {
          url = new URL(link.href, window.location.origin);
        } catch (_) {
          return;
        }

        const productJsonUrl = `${url.origin}${url.pathname}.js`;
        fetch(productJsonUrl, { credentials: 'same-origin' })
          .then((response) => (response.ok ? response.json() : null))
          .then((product) => {
            if (!product) return;
            const available = product.available === true ||
              (Array.isArray(product.variants) && product.variants.some((variant) => variant.available === true));
            if (!available) item.remove();
          })
          .catch(() => {});
      });
    };

    const schedulePrune = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(prunePredictiveSoldOut);
    };

    document.addEventListener('DOMContentLoaded', schedulePrune, { once: true });
    new MutationObserver(schedulePrune).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-hide-sold-out-pre-wishlist"]) return;
  try {
    
  (() => {
    let scheduled = false;

    const prunePredictiveSoldOut = () => {
      scheduled = false;
      const items = Array.from(
        document.querySelectorAll('#predictive-search-results-products-list .predictive-search__list-item:not([data-cb-stock-checked])')
      );
      if (!items.length) return;

      items.forEach((item) => {
        item.dataset.cbStockChecked = 'true';
        const link = item.querySelector('a[href*="/products/"]');
        if (!link) return;

        let url;
        try {
          url = new URL(link.href, window.location.origin);
        } catch (_) {
          return;
        }

        const productJsonUrl = `${url.origin}${url.pathname}.js`;
        fetch(productJsonUrl, { credentials: 'same-origin' })
          .then((response) => (response.ok ? response.json() : null))
          .then((product) => {
            if (!product) return;
            const available = product.available === true ||
              (Array.isArray(product.variants) && product.variants.some((variant) => variant.available === true));
            if (!available) item.remove();
          })
          .catch(() => {});
      });
    };

    const schedulePrune = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(prunePredictiveSoldOut);
    };

    document.addEventListener('DOMContentLoaded', schedulePrune, { once: true });
    new MutationObserver(schedulePrune).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-hide-sold-out"]) return;
  try {
    
  (() => {
    let scheduled = false;

    const prunePredictiveSoldOut = () => {
      scheduled = false;
      const items = Array.from(
        document.querySelectorAll('#predictive-search-results-products-list .predictive-search__list-item:not([data-cb-stock-checked])')
      );
      if (!items.length) return;

      items.forEach((item) => {
        item.dataset.cbStockChecked = 'true';
        const link = item.querySelector('a[href*="/products/"]');
        if (!link) return;

        let url;
        try {
          url = new URL(link.href, window.location.origin);
        } catch (_) {
          return;
        }

        const productJsonUrl = `${url.origin}${url.pathname}.js`;
        fetch(productJsonUrl, { credentials: 'same-origin' })
          .then((response) => (response.ok ? response.json() : null))
          .then((product) => {
            if (!product) return;
            const available = product.available === true ||
              (Array.isArray(product.variants) && product.variants.some((variant) => variant.available === true));
            if (!available) item.remove();
          })
          .catch(() => {});
      });
    };

    const schedulePrune = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(prunePredictiveSoldOut);
    };

    document.addEventListener('DOMContentLoaded', schedulePrune, { once: true });
    new MutationObserver(schedulePrune).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-home-phase4-pre-category-2026-09-07"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHeroFit = () => {
      document.querySelectorAll('.cb4-hero').forEach((hero) => {
        if (hero.dataset.viewportFitReady) return;
        hero.dataset.viewportFitReady = 'true';
        let frame;
        const fit = () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const top = Math.max(0, hero.getBoundingClientRect().top + window.scrollY);
            hero.style.setProperty('--cb4-hero-height', Math.max(0, window.innerHeight - top) + 'px');
          });
        };
        const observer = new ResizeObserver(fit);
        document.querySelectorAll('.shopify-section-group-header-group, .cb4-top-trust').forEach((element) => observer.observe(element));
        window.addEventListener('resize', fit, { passive: true });
        window.addEventListener('load', fit, { once: true });
        document.fonts.ready.then(fit);
        fit();
        document.addEventListener('shopify:section:unload', (event) => {
          if (!event.target.contains(hero)) return;
          observer.disconnect();
          window.removeEventListener('resize', fit);
          cancelAnimationFrame(frame);
        });
      });
    };
    initHeroFit();
    document.addEventListener('shopify:section:load', initHeroFit);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-home-phase4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHeroFit = () => {
      document.querySelectorAll('.cb4-hero').forEach((hero) => {
        if (hero.dataset.viewportFitReady) return;
        hero.dataset.viewportFitReady = 'true';
        let frame;
        const fit = () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const top = Math.max(0, hero.getBoundingClientRect().top + window.scrollY);
            hero.style.setProperty('--cb4-hero-height', Math.max(0, window.innerHeight - top) + 'px');
          });
        };
        const observer = new ResizeObserver(fit);
        document.querySelectorAll('.shopify-section-group-header-group, .cb4-top-trust').forEach((element) => observer.observe(element));
        window.addEventListener('resize', fit, { passive: true });
        window.addEventListener('load', fit, { once: true });
        document.fonts.ready.then(fit);
        fit();
        document.addEventListener('shopify:section:unload', (event) => {
          if (!event.target.contains(hero)) return;
          observer.disconnect();
          window.removeEventListener('resize', fit);
          cancelAnimationFrame(frame);
        });
      });
    };
    initHeroFit();
    document.addEventListener('shopify:section:load', initHeroFit);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-phase2-fit-comparison"]) return;
  try {
    
  (() => {
    const mount = () => {
      const node = document.getElementById('cb-fit-comparison');
      if (!node || node.dataset.cbFitMounted === 'true') return;

      const info = document.querySelector('product-info .product__info-container');
      if (!info) return;

      const accordions = Array.from(info.querySelectorAll('.product__accordion'));
      const sizeGuide = accordions.find((accordion) => /size\s*guide/i.test(accordion.textContent || ''));

      if (sizeGuide) {
        sizeGuide.insertAdjacentElement('afterend', node);
      } else {
        const variantArea = info.querySelector('variant-selects, variant-radios, .product-form__input');
        if (variantArea) variantArea.insertAdjacentElement('beforebegin', node);
        else info.appendChild(node);
      }

      node.hidden = false;
      node.dataset.cbFitMounted = 'true';
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mount, { once: true });
    } else {
      mount();
    }

    document.addEventListener('shopify:section:load', mount);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb4-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHeroFit = () => {
      document.querySelectorAll('.cb4-hero').forEach((hero) => {
        if (hero.dataset.viewportFitReady) return;
        hero.dataset.viewportFitReady = 'true';
        let frame;
        const fit = () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            if (window.matchMedia('(max-width: 989px)').matches) {
              hero.style.removeProperty('--cb4-hero-height');
              return;
            }
            const top = Math.max(0, hero.getBoundingClientRect().top + window.scrollY);
            hero.style.setProperty('--cb4-hero-height', Math.max(0, window.innerHeight - top) + 'px');
          });
        };
        const observer = new ResizeObserver(fit);
        document.querySelectorAll('.shopify-section-group-header-group, .cb4-top-trust').forEach((element) => observer.observe(element));
        window.addEventListener('resize', fit, { passive: true });
        window.addEventListener('load', fit, { once: true });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
        fit();
        document.addEventListener('shopify:section:unload', (event) => {
          if (!event.target.contains(hero)) return;
          observer.disconnect();
          window.removeEventListener('resize', fit);
          cancelAnimationFrame(frame);
        });
      });
    };
    initHeroFit();
    document.addEventListener('shopify:section:load', initHeroFit);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
